import BaseService from "./base.service";
//import http from '../http-common';
class EmploiCertificationFileService extends BaseService {
  constructor() {
    super("emploi-certification-file");
  }
}

export default new EmploiCertificationFileService();
